import { render, staticRenderFns } from "./vBoolean.vue?vue&type=template&id=fcaa04e4&lang=html&"
import script from "./vBoolean.vue?vue&type=script&lang=js&"
export * from "./vBoolean.vue?vue&type=script&lang=js&"
import style0 from "./vBoolean.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
